import clsx from 'clsx';
import { useState } from 'react';
import { Order, OrderStatus } from '../api-new';
import { PencilIcon } from '../icons/pencil';
import { TickIcon } from '../icons/tick';
import { COLS_FULL } from './columns';

export const OrderRow = (ps: {
  order: Order;
  selected: boolean;
  onSelect(): void;
}) => {
  const [editing, setEditing] = useState(false);
  const cell_colors = clsx(
    'border-b',
    editing ? 'bg-orange-100' : 'group-even:bg-neutral-100',
  );

  const colored =
    ps.order.wk_status_code === OrderStatus.SCHEDULED ||
    ps.order.wk_status_code === OrderStatus.STANDBY;

  return (
    <tr className="group">
      <td className={clsx('px-1', cell_colors)}>
        {colored && (
          <div
            className={clsx(
              'w-6 h-6 flex items-center justify-center border-2 border-blue-500 rounded-md',
              ps.selected ? 'bg-blue-500' : 'bg-blue-100',
            )}
            onClick={ps.onSelect}>
            {ps.selected && <TickIcon className="fill-white w-4 h-4" />}
          </div>
        )}
      </td>
      {COLS_FULL.map((col, i) => (
        <td
          key={i}
          className={clsx(
            'py-5 px-1',
            cell_colors,
            col.truncate &&
              'text-ellipsis max-w-1 overflow-hidden whitespace-nowrap',
          )}>
          {col.cell ? col.cell(ps.order) : ps.order[col.key]}
        </td>
      ))}
      <td className={clsx('px-2', cell_colors)}>
        {colored &&
          (editing ? (
            <TickIcon
              className="cursor-pointer bg-orange-500 fill-white rounded-sm p-0.5 h-6 w-6"
              onClick={() => setEditing(false)}
            />
          ) : (
            <PencilIcon
              className="cursor-pointer hover:scale-110 fill-orange-500"
              onClick={() => setEditing(true)}
            />
          ))}
      </td>
    </tr>
  );
};
